import { mediaUrl } from "@/lib/api";

/**
 * Brand mark: uploaded logo (from admin > Görseller) if present, otherwise the
 * typographic wordmark. Used in header and footer.
 */
export const BrandLogo = ({ settings, size = "md", className = "", idPrefix = "header" }) => {
  const logo = settings && settings.logo_url ? mediaUrl(settings.logo_url) : null;
  const h = size === "lg" ? "h-12 sm:h-14" : "h-9 sm:h-11";
  if (logo) {
    return (
      <img
        src={logo}
        alt={(settings && settings.brand_name) || "Ankara Düğün Fotoğrafı"}
        className={`${h} w-auto max-w-[220px] object-contain ${className}`}
        data-testid={`${idPrefix}-brand-logo-image`}
      />
    );
  }
  const domain = (settings && settings.domain) || "ankaradugunfotografi.com";
  return (
    <span className={`flex flex-col leading-none ${className}`} data-testid={`${idPrefix}-brand-logo-text`}>
      <span className={`font-display ${size === "lg" ? "text-2xl" : "text-[15px] sm:text-xl"} text-[#F7F2E8] tracking-tight whitespace-nowrap`}>
        Ankara <span className="text-[#C8A24A]">Düğün</span> Fotoğrafı
      </span>
      <span className="text-[10px] tracking-[0.18em] text-[#CFC6B8] mt-1" data-testid={`${idPrefix}-brand-logo-domain`}>{domain}</span>
    </span>
  );
};

export default BrandLogo;
